export default {
  properties: {
    email: {
      allowEmpty: false,
      maxLength: 320,
      pattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,20}$/,
      required: true,
      messages: {
        allowEmpty: "Введите ваш email",
        pattern: "Email введён некорректно",
        maxLength: "Email слишком длинный",
      },
    },
    message: {
      allowEmpty: false,
      maxLength: 1000,
      required: true,
      minLength: 5,
      messages: {
        allowEmpty: "Введите текст сообщения",
        maxLength: "Слишком длинное сообщение",
        minLength: "Слишком короткое сообщение",
      },
    },
    name: {
      allowEmpty: false,
      maxLength: 30,
      minLength: 2,
      pattern: /^[a-zA-Zа-яА-Я]+(?:\s+[a-zA-Zа-яА-Я]+)*$/,
      required: true,
      type: "string",
      messages: {
        required: "Обязательно для заполнения",
        allowEmpty: "Введите ваше имя",
        maxLength: "Слишком длинное имя",
        minLength: "Слишком короткое имя",
        pattern: "Недопустимое имя",
      },
    },
  },
};
